import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20manhwa%20themed%20banner%20background%2C%20warm%20golden%20and%20soft%20rose%20color%20gradient%2C%20abstract%20comic%20panel%20layout%20with%20subtle%20line%20art%2C%20elegant%20and%20modern%20composition%2C%20minimalist%20design%2C%20soft%20glowing%20effects%2C%20no%20text%2C%20clean%20artistic%20style&width=1800&height=800&seq=hero-banner-main&orientation=landscape"
        alt="韩漫漫画网 - 最新高清免费韩国漫画"
        title="韩漫漫画网 - 最新高清免费韩国漫画大全"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            <Link to="/" className="text-white cursor-pointer">韩漫漫画网</Link>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-6 max-w-xl mx-auto leading-relaxed">
            最新高清免费韩国漫画大全 · 热门韩漫在线观看 · 画面精美 · 更新及时
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium text-sm border border-white/30 hover:bg-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-accent-500"></span>
        <span className="w-2 h-2 rounded-full bg-white/50"></span>
        <span className="w-2 h-2 rounded-full bg-white/50"></span>
        <span className="w-2 h-2 rounded-full bg-white/50"></span>
      </div>
    </section>
  );
}